import { ArrowRight, BookOpen } from 'lucide-react';
import { previewChapters } from '../data';
import type { PageId } from '../types';

interface PreviewPageProps {
  page: Exclude<PageId, 'day2' | 'guide'>;
}

export function PreviewPage({ page }: PreviewPageProps) {
  const preview = previewChapters[page];

  return (
    <section className="preview-page">
      <div className="preview-card">
        <BookOpen aria-hidden="true" />
        <span>章节规划</span>
        <h1>{preview.title}</h1>
        <h2>{preview.question}</h2>
        <p>{preview.text}</p>
        <div className="topic-list">
          {preview.topics.map((topic) => (
            <b key={topic}>{topic}</b>
          ))}
        </div>
        <a href="#day2">
          先回到 Day 2 样板
          <ArrowRight aria-hidden="true" />
        </a>
      </div>
    </section>
  );
}
